// All arguments are Iris
// TODO consider rephrasing label to type, to allow for future DTDL labels on relationships.
class Edge {
  // TODO introduce type check for arguments...
  constructor(source, target, label) {
    this.source = source
    this.target = target
    this.label = label
  }

  // Parameter edge is of type Edge.
  equals(edge) {
    return (
      this.source.equals(edge.source) &&
      this.target.equals(edge.target) &&
      this.label.equals(edge.label)
    )
  }
}

export { Edge }
